import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { getUsersMeCategoriesSelector } from "./getUsersMeCategoriesSelector";

export const categoriesDataSelector = createDraftSafeSelector(
  [getUsersMeCategoriesSelector],
  (categories) => {
    return categories.data;
  },
);
